// extracted by mini-css-extract-plugin
module.exports = {"invert":"BackgroundColor_invert__8yPWe"};
module.exports.__checksum = "cdc69df701c0"
